import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send/receive httpOnly auth cookie
});

// Force-change-password gate: any 423 response redirects the user to the change-password
// page (unless we're already there or on the login page). This is a defensive layer on top of
// the backend enforcement — the backend is the source of truth.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (typeof window !== "undefined" && err?.response?.status === 423) {
      const p = window.location.pathname;
      if (!p.startsWith("/care-portal/admin/change-password") && !p.startsWith("/care-portal/admin/login")) {
        window.location.replace("/care-portal/admin/change-password");
      }
    }
    return Promise.reject(err);
  },
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
